export default "__VITE_ASSET__t2l5_TuG__"